import Collapse from './Collapse'
export * from './interface'
export default Collapse
